import { usePerformanceClient } from '@depict-ai/react-ui';
import { generateEventId, urlify } from '../../utils/string';
import { deepClone } from '../../utils/object';

const cartAnalytics = (product, itemObj = {}, setup, originalProduct, fromList = {}, remove = false, quantity = 1) => {
	const { currency } = setup.countries[setup.country];
	const uniqueEventID = generateEventId();
	const { dpc } = usePerformanceClient();

	if (!product && originalProduct) {
		// Create product in selection cache.
		product = {
			generatedClientSide: true,
			uri: originalProduct.uri,
			name: originalProduct.name,
			sku: originalProduct.sku,
			id: `p${originalProduct.silkProduct}-v${originalProduct.silkVariant}`,
			brand: originalProduct.brandName,
			canonicalUri: originalProduct.canonicalUri,
			image: originalProduct.media.map((image) => image.sources.big.url).slice(0, 2),
			categories: Object.keys(originalProduct.categories).reduce((acc, category) => ({ ...acc, [category]: { uri: originalProduct.categories[category].uri, name: originalProduct.categories[category].name } }), {}),
			localized: deepClone(originalProduct.localized),
			price: { ...originalProduct.markets[setup.market].pricesByPricelist[setup.pricelist] },
			sizes: Object.keys(originalProduct.items).map((size) => ({ name: originalProduct.items[size].name, item: size, stock: originalProduct.items[size].stockByMarket[setup.market] })),
			inStock: originalProduct.markets[setup.market].stockOfAllItems,
		};
	}

	if (typeof window.dataLayer === 'undefined') window.dataLayer = [];
	const itemCategory = product.canonicalUri.split('/').slice(0, -1).reduce((acc, category, j) => ({ ...acc, [`item_category${j > 0 ? j + 1 : ''}`]: category }), {});

	if (remove) {
		window.dataLayer.push({ ecommerce: null });
		window.dataLayer.push({
			event: 'remove_from_cart',
			ecommerce: {
				'x-fb-event_id': uniqueEventID,
				currency,
				items: [{
					item_name: product.name,
					item_id: product.id.replace(/p(\d+)-v.*/, '$1'),
					price: product.price.priceAsNumber,
					currency,
					item_brand: product.brand,
					...itemCategory,
					item_list_id: urlify(fromList[product.id] || ''),
					item_list_name: fromList[product.id] || '',
					item_variant: product.variantName,
					quantity: `${quantity}`,
				}],
			},
		});
		return;
	}

	dpc.sendAddToCartEvent({ product_id: itemObj.sku });

	window.dataLayer.push({ values: null });
	window.dataLayer.push({
		event: 'AddToCart',
		event_id: uniqueEventID,
		values: {
			value: product.price.priceAsNumber,
			currency,
			content_name: product.name,
			content_type: 'product',
			content_ids: [`1/${setup.country.toLowerCase()}-${product.id}-s`],
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'AddToCartGA',
		ecommerce: {
			currencyCode: currency,
			add: {
				products: [{
					name: product.name,
					id: product.id.replace(/p(\d+)-v.*/, '$1'),
					price: product.price.priceAsNumber,
					brand: product.brand,
					category: product.canonicalUri.split('/').slice(0, -1).join('/'),
					variant: product.variantName,
					quantity,
				}],
			},
		},
	});

	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: 'add_to_cart',
		ecommerce: {
			'x-fb-event_id': uniqueEventID,
			currency,
			items: [{
				item_name: product.name,
				item_id: product.id.replace(/p(\d+)-v.*/, '$1'),
				price: product.price.priceAsNumber,
				currency,
				item_brand: product.brand,
				...itemCategory,
				item_list_id: urlify(fromList[product.id] || ''),
				item_list_name: fromList[product.id] || '',
				item_variant: product.variantName,
				quantity: `${quantity}`,
			}],
		},
	});
};

export default cartAnalytics;
